export enum DocumentFilesType {
  REGULATION = "REGULATION",
  TUTORIAL = "TUTORIAL",
}
export type DocumentFiles = {
  id: string;
  title: string;
  description?: string;
  category: string;
  type: DocumentFilesType;
  urlPath: string;
  order: number;
  isPrivate: boolean;
  allowedRoles: string[];

  createdAt: Date;
  modifiedAt?: Date | null;

}

export type DocumentFilesPayload = {
  type: DocumentFilesType
} & UpdateInput;

export type UpdateInput = {
  id?: string;
  title: string;
  description?: string;
  category: string;
  urlPath: string;
  order?: number;
  isPrivate: boolean;
  allowedRoles: string[];
};